"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.healthComparison_enDe = void 0;
exports.healthComparison_enDe = {
    metaData: {
        prismicId: 'ZrsNwRIAAC4Ar_11',
        type: 'comparisontable',
        uid: 'health-comparison',
        lang: 'en-de',
        lastPublished: '2024-09-23T15:24:51+0000',
    },
    tableData: {
        title: 'Health',
        collapsibleSections: false,
        hideDetails: false,
        tableData: [
            {
                section: {
                    title: '',
                },
                rows: [
                    [
                        {
                            cellId: 'table_row$2ff653d7-bf78-4c49-bfed-0500765060c3_header',
                            text: 'How they compare',
                            description: null,
                        },
                        {
                            cellId: 'table_row$2ff653d7-bf78-4c49-bfed-0500765060c3_0',
                            type: 'CTA',
                            title: 'Public',
                            grey: false,
                            narrow: false,
                            buttonCaption: 'Learn more',
                            href: 'https://feather-insurance.com/health-insurance/public',
                        },
                        {
                            cellId: 'table_row$2ff653d7-bf78-4c49-bfed-0500765060c3_1',
                            type: 'CTA',
                            title: 'Private',
                            grey: false,
                            narrow: false,
                            buttonCaption: 'Learn more',
                            href: 'https://feather-insurance.com/health-insurance/private',
                        },
                        {
                            cellId: 'table_row$2ff653d7-bf78-4c49-bfed-0500765060c3_2',
                            type: 'CTA',
                            title: 'Expat',
                            grey: false,
                            narrow: false,
                            buttonCaption: 'Learn more',
                            href: 'https://feather-insurance.com/health-insurance/expat/short-term',
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$9c1d4a39-467e-4dc3-83e6-52f6b0ab5d1b_header',
                            text: 'Your contribution',
                            description: null,
                        },
                        {
                            cellId: 'table_row$9c1d4a39-467e-4dc3-83e6-52f6b0ab5d1b_0',
                            text: '~€250-450',
                            fontVariant: 'PRICE',
                        },
                        {
                            cellId: 'table_row$9c1d4a39-467e-4dc3-83e6-52f6b0ab5d1b_1',
                            text: '~€150-300',
                            fontVariant: 'PRICE',
                        },
                        {
                            cellId: 'table_row$9c1d4a39-467e-4dc3-83e6-52f6b0ab5d1b_2',
                            text: '~€72-200',
                            fontVariant: 'PRICE',
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$35e20e12-2ebc-4f9e-9ac9-3fd207678863_header',
                            text: 'Coverage',
                            description: null,
                        },
                        {
                            cellId: 'table_row$35e20e12-2ebc-4f9e-9ac9-3fd207678863_0',
                            text: 'Comprehensive',
                        },
                        {
                            cellId: 'table_row$35e20e12-2ebc-4f9e-9ac9-3fd207678863_1',
                            text: 'Comprehensive',
                        },
                        {
                            cellId: 'table_row$35e20e12-2ebc-4f9e-9ac9-3fd207678863_2',
                            text: 'Basic-moderate depending on plan',
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$b53e272c-e6b5-43ed-9c86-8ae67180e894_header',
                            text: 'Visa validity',
                            description: null,
                        },
                        {
                            cellId: 'table_row$b53e272c-e6b5-43ed-9c86-8ae67180e894_0',
                            text: 'All visa types',
                        },
                        {
                            cellId: 'table_row$b53e272c-e6b5-43ed-9c86-8ae67180e894_1',
                            text: 'Short-term plan: first-time visas only. Long-term plan: all visa types.',
                        },
                        {
                            cellId: 'table_row$b53e272c-e6b5-43ed-9c86-8ae67180e894_2',
                            text: 'Short-term plan: first-time visas only. Long-term plan: visa renewals.',
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$70fd3e21-f8d9-4129-aa3e-c8a618067ace_header',
                            text: 'Family coverage',
                            description: null,
                        },
                        {
                            cellId: 'table_row$70fd3e21-f8d9-4129-aa3e-c8a618067ace_0',
                            text: 'Free',
                        },
                        {
                            cellId: 'table_row$70fd3e21-f8d9-4129-aa3e-c8a618067ace_1',
                            text: 'Pay per dependent',
                        },
                        {
                            cellId: 'table_row$70fd3e21-f8d9-4129-aa3e-c8a618067ace_2',
                            text: 'Pay per dependent',
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$4b187606-13db-47f2-8b4b-fae732061f84_header',
                            text: 'Cancellation period',
                            description: null,
                        },
                        {
                            cellId: 'table_row$4b187606-13db-47f2-8b4b-fae732061f84_0',
                            text: '2 months',
                        },
                        {
                            cellId: 'table_row$4b187606-13db-47f2-8b4b-fae732061f84_1',
                            text: '2 months',
                        },
                        {
                            cellId: 'table_row$4b187606-13db-47f2-8b4b-fae732061f84_2',
                            text: '1 month',
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$ba63a0da-9d00-4700-8061-bbbf5cd91b7f_header',
                            text: 'Getting your confirmation of coverage',
                            description: null,
                        },
                        {
                            cellId: 'table_row$ba63a0da-9d00-4700-8061-bbbf5cd91b7f_0',
                            text: '1-5 days',
                        },
                        {
                            cellId: 'table_row$ba63a0da-9d00-4700-8061-bbbf5cd91b7f_1',
                            text: '3-10 days',
                        },
                        {
                            cellId: 'table_row$ba63a0da-9d00-4700-8061-bbbf5cd91b7f_2',
                            text: 'Short-term plan: 0hrs. Long-term plan: 24hrs.',
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$6eafee52-0e8f-4a99-9992-5882b6495bca_header',
                            text: 'Paying for health services',
                            description: null,
                        },
                        {
                            cellId: 'table_row$6eafee52-0e8f-4a99-9992-5882b6495bca_0',
                            text: 'Insurance card',
                        },
                        {
                            cellId: 'table_row$6eafee52-0e8f-4a99-9992-5882b6495bca_1',
                            text: 'Out of pocket',
                        },
                        {
                            cellId: 'table_row$6eafee52-0e8f-4a99-9992-5882b6495bca_2',
                            text: 'Out of pocket',
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$0c0da6c0-6b30-412e-a124-296e595b0a04_header',
                            text: 'Pre-existing conditions',
                            description: null,
                        },
                        {
                            cellId: 'table_row$0c0da6c0-6b30-412e-a124-296e595b0a04_0',
                            checkmarkValue: true,
                        },
                        {
                            cellId: 'table_row$0c0da6c0-6b30-412e-a124-296e595b0a04_1',
                            checkmarkValue: true,
                        },
                        {
                            cellId: 'table_row$0c0da6c0-6b30-412e-a124-296e595b0a04_2',
                            checkmarkValue: false,
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$3b604e94-9768-4d6f-9b84-0df2728df647_header',
                            text: 'Social contributions',
                            description: 'Pflegepflichtversicherung',
                        },
                        {
                            cellId: 'table_row$3b604e94-9768-4d6f-9b84-0df2728df647_0',
                            checkmarkValue: true,
                        },
                        {
                            cellId: 'table_row$3b604e94-9768-4d6f-9b84-0df2728df647_1',
                            checkmarkValue: true,
                        },
                        {
                            cellId: 'table_row$3b604e94-9768-4d6f-9b84-0df2728df647_2',
                            checkmarkValue: false,
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$06589a69-a299-4756-b50a-14311ed1cef4_header',
                            text: 'Cost change over time',
                            description: null,
                        },
                        {
                            cellId: 'table_row$06589a69-a299-4756-b50a-14311ed1cef4_0',
                            text: 'Historically increased by 3.4%/year. Stays stable at retirement',
                        },
                        {
                            cellId: 'table_row$06589a69-a299-4756-b50a-14311ed1cef4_1',
                            text: 'Historically increased by 2.8%/year. Decreases at retirement',
                        },
                        {
                            cellId: 'table_row$06589a69-a299-4756-b50a-14311ed1cef4_2',
                            text: 'Short-term plan: goes up after 64.  Long-term plan: increases gradually with age',
                        },
                    ],
                ],
            },
        ],
    },
};
